import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/owowagency.webp';
import screenshot_target from '../../../images/letterfunnel/pieterjanpieters.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Pieter-Jan Pieters"
      firstname="Pieter-Jan"
      companyname="OWOW Agency"
      competition="Label A en Freshheads"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pieterjanpieters.js